export enum FilterOptionType {
  Inline = 'inline',
  Dropdown = 'dropdown',
}
